import { API_BASE_URL } from '@webcatalog/constants/api-base-url';

// Query shape defined by apps/webcatalog-api/src/routes/api.download.ts.
export type DownloadPlatform = 'macos' | 'windows' | 'linux';
export type DownloadPackageFormat = 'appimage' | 'deb' | 'rpm' | 'tar';
export type DownloadArch = 'x64' | 'arm64';

export const getDownloadUrl = ({
  platform,
  packageFormat,
  arch,
}: {
  platform: DownloadPlatform;
  packageFormat?: DownloadPackageFormat;
  arch?: DownloadArch;
}) => {
  const searchParams = new URLSearchParams({
    appId: 'webcatalog',
    platform,
  });

  if (packageFormat) {
    searchParams.set('packageFormat', packageFormat);
  }

  if (arch) {
    searchParams.set('arch', arch);
  }

  return `${API_BASE_URL}/api/download?${searchParams.toString()}`;
};
